export { default, type AvatarProps, type AvatarComponentProps } from './Avatar';
